import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { track } from "@/lib/analytics";
import { BRAND } from "@/data/content";

export default function CTASection() {
  return (
    <section
      data-testid="cta-section"
      className="relative py-20 sm:py-28 lg:py-40 px-5 sm:px-6 lg:px-12"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="relative overflow-hidden aurora-border rounded-md p-6 sm:p-10 md:p-16 lg:p-24">
          <div
            aria-hidden
            className="aurora-orb aurora-orb-magenta orb-anim-a"
            style={{ width: 380, height: 380, top: -160, right: -120, opacity: 0.16 }}
          />
          <div
            aria-hidden
            className="aurora-orb aurora-orb-azure orb-anim-b"
            style={{ width: 300, height: 300, bottom: -120, left: -80, opacity: 0.12 }}
          />
          <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-8 sm:gap-10 items-end">
            <div className="lg:col-span-7">
              <p className="overline">Ready when you are</p>
              <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl tracking-tight leading-[1] mt-5 sm:mt-6">
                Unlock the{" "}
                <span className="italic text-aurora">GoldKey</span>
                <br />
                to your next chapter.
              </h2>
              <p className="text-neutral-700 mt-5 sm:mt-6 max-w-xl text-base sm:text-lg">
                Starter at <span className="text-aurora-static font-medium">$49/mo</span>. Growth at <span className="text-aurora-static font-medium">$199/mo</span>. Annual saves 20%. You&apos;ll be inside the Studio in under a minute - or book a discovery call and we&apos;ll sketch your path first.
              </p>
            </div>
            <div className="lg:col-span-4 lg:col-start-9 flex flex-col gap-3">
              <Link
                to="/pricing"
                className="btn-aurora justify-center"
                data-testid="cta-primary"
                onClick={() => track("CTA Clicked", { location: "cta_section", label: "See plans" })}
              >
                See plans <ArrowUpRight size={16} />
              </Link>
              <a
                href={BRAND.calendly}
                target="_blank"
                rel="noreferrer"
                className="btn-ghost justify-center"
                data-testid="cta-secondary"
                onClick={() => track("CTA Clicked", { location: "cta_section", label: "Book a call", destination: "calendly" })}
              >
                Book a call <ArrowUpRight size={16} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
